<dls-popup class="dialog-width pt-dialog-context pt-popup">
  <dls-dialog>
    <dls-dialog-header>
      <span class="pt-title">{{messageTitle}}</span>
    </dls-dialog-header>
    <dls-dialog-content>
      <p>
        {{messageText}}
      </p>
      <p>
        {{closeWindowText}}
      </p>
    </dls-dialog-content>
  </dls-dialog>
</dls-popup>
